import ColorsStyles from '@Styles/colors.scss';
import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import PopoverMenu from '@Components/PopoverMenu/PopoverMenu';
import PopoverMenuItem from '@Components/PopoverMenu/PopoverMenuItem';
import { selectedFolderJobIdState } from '@Data/folders/Reducer';
import { selectedProjectState } from '@Data/projects/Reducer';
import { IAnalysisEntity } from '@Data/qualityControl/Interfaces';
import Styles from './QcEntitiesTable.scss';

interface IQcFolderMenuProps {
    entity: IAnalysisEntity;
    collection: string;
    selectedBackgroundColor?: string;
    selectedBtnColor?: string;
}

const QcEnityMenu = (props: IQcFolderMenuProps) => {
    const { entity, collection, selectedBackgroundColor, selectedBtnColor } =
        props;

    const bgColor =
        selectedBackgroundColor ?? ColorsStyles.ikeSecondaryDarkGreen;
    const btnColor = selectedBtnColor ?? '#fff';

    const selectedProject = useSelector(selectedProjectState);
    const jobId = useSelector(selectedFolderJobIdState);
    const departmentId = selectedProject.department_id;
    const originalCollectionUuid = collection;
    const menuRef = useRef<PopoverMenu>();
    const [bgColour, setBgColour] = useState(bgColor);
    const [btnColour, setBtnColour] = useState(btnColor);

    const ikeOfficeEntityLink = `https://office.ikegps.com/#/measure?d=${departmentId}&t=${jobId}&collection=${originalCollectionUuid}`;

    const handleSetColours = (isOpen: boolean) => {
        if (isOpen) {
            setBtnColour('#000');
            setBgColour('#fff');
        } else {
            setBgColour(bgColor);
            setBtnColour(btnColor);
        }
    };

    const handleClose = () => {
        handleSetColours(false);
    };

    const handleOpenIkeOfficeLink = () => {
        window.open(ikeOfficeEntityLink, '_blank');
    };

    return (
        <div
            className={Styles.qcOptionMenuContainer}
            style={{ backgroundColor: bgColour }}
        >
            <PopoverMenu
                id={`entity-menu-${entity.entity_version_id}`}
                ref={menuRef}
                iconColour={btnColour}
                btnContainerStyle={{ backgroundColor: bgColour }}
                onClose={handleClose}
                onOpen={() => handleSetColours(true)}
                isHidden={false}
            >
                <PopoverMenuItem
                    id={`${entity.entity_version_id}-ike-office-link`}
                    onClick={handleOpenIkeOfficeLink}
                    text="Open in Ike Office"
                    parentRef={menuRef}
                />
            </PopoverMenu>
        </div>
    );
};

export default QcEnityMenu;
